import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, Col, Row,
} from 'reactstrap';
import classnames from 'classnames';
import './OpportunityCard.scss';
import Translate from '@securitize/ui-components/i18n/Translate/Translate';
import Column from './components/Column';
import { MixPanel } from '../../../../../../../utils/helpers/mixPanel';
import SanitizedReactHtmlParser from '../../../../../../../utils/helpers/SanitizedReactHtmlParser';

const OpportunityCard = (props) => {
  const { opportunity, onOpportunitySelect, isGridView } = props;
  return (
    <Card className={classnames('opportunity-card border-0 box-shadow mt-4 p-0',
      { 'opportunity-card__grid': isGridView })}
    >
      <Row className="opportunity-card__row">
        <Col
          className={classnames({
            'opportunity-card__row__grid': isGridView,
          })}
          xs="12"
          md="4"
          lg="4"
          xl="4"
        >
          <div
            className={classnames('opportunity-card__row__img-wrapper', {
              'opportunity-card__row__img-wrapper__grid': isGridView,
            })}
            style={{ backgroundImage: `url(${opportunity.image})` }}
          >
            <div className="opportunity-card__row__img-wrapper__label">
              <Translate translationKey="Texts.open-for-investment" />
            </div>
          </div>
        </Col>
        <Col className={classnames({
          'opportunity-card__row__content-grid': isGridView,
        })}
        >
          <div
            className={classnames('p-4', {
              'opportunity-card__row__content-grid__container': isGridView,
            })}
          >
            <div className={classnames('font-28', {
              'opportunity-card__row__content-grid__container__title': isGridView,
            })}
            >
              {opportunity.title}
            </div>
            <div className={classnames('subtext mt-3 font-16', { 'opportunity-card__row__content': isGridView })}>
              {SanitizedReactHtmlParser(opportunity.content)}
            </div>
            <div className={classnames('mt-3', {
              'opportunity-card__row__content-grid__container__attributes': isGridView,
            })}
            >
              <Row className={classnames('opportunity-card__table', { 'opportunity-card__table__grid': isGridView })}>
                {opportunity.attributes
                  .sort((first, second) => first.order - second.order)
                  .map((attribute) => {
                    const hasContent = !!attribute.content.trim();
                    return hasContent && (
                      <Column
                        key={attribute.content}
                        content={attribute.content}
                        opportunityId={opportunity.id}
                        isGridView={isGridView}
                      />
                    );
                  })}
              </Row>
            </div>
            <div className={classnames({
              'opportunity-card__row__content-grid__container__footer': isGridView,
            })}
            >
              <Button
                id={`btn-opportunity-${opportunity.id}`}
                onClick={() => {
                  MixPanel.track('opportunity-click', { opportunityId: opportunity.id });
                  onOpportunitySelect(opportunity);
                }}
                size="lg"
                className={
                  classnames('opportunity-card__btn font-weight-bold text-white font-16  mx-auto issuer-button-primary', {
                    'opportunity-card__btn__grid': isGridView,
                    'max-width-330': !isGridView,
                  })
                }
              >
                <Translate translationKey="Texts.view-investment-details" />
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

OpportunityCard.defaultProps = {
  opportunity: null,
  onOpportunitySelect: () => undefined,
};

OpportunityCard.propTypes = {
  opportunity: PropTypes.objectOf(PropTypes.any),
  onOpportunitySelect: PropTypes.func,
  isGridView: PropTypes.bool.isRequired,
};

export default OpportunityCard;
